<script setup>
import {cloneDeep} from "lodash"
export default {
    name: 'RfqFilePostingModal',
    props: {
        multipleFilePosting: Array,
        modalTitle: String,
        filePostingType: String,
        loading: Boolean,
        publicPostLabels: Array
    },
    methods: {
        addMoreMultipleFiles(){
            this.multipleFilePosting.push({
                id: 0,
                title: '',
                description: '',
                search: false,
            });
        },
        async onSubmitPublicPostFile(){
            let data = cloneDeep(this.multipleFilePosting)
            this.$emit('saveFilePosting', data)
        },
    }
}
</script>
<template>
    <b-modal
        id="rfq-posting-file-modal"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <div v-if="loading">
            <LoadingTemplate />
        </div>
        <div v-else>
            <form @submit.prevent="onSubmitPublicPostFile">
                    <div v-for="(file, index) in multipleFilePosting" :key="index">
                        <hr v-if="index > 0">
                        <div class="mb-3" >
                            <div class="d-flex align-items-center justify-content-between">
                                <label
                                    >Title</label
                                >
                                <div class="d-flex align-items-center"  v-if="filePostingType === 'add'">
                                    <span>({{index+1}})</span>
                                    <a href="javascript:void(0);" class="text-danger" @click="removeMultipleFiles(index)"><i class="bx bx-trash"></i></a>
                                </div>
                            </div>
                            <select class="form-select" v-model="file.title">
                                <option></option>
                                <option v-for="x in publicPostLabels" :key="x.id">{{x.title}}</option>
                            </select>
                        </div>
                        <div class="mb-3">
                            <label
                                >Description</label
                            >
                            <input
                                type="text"
                                class="form-control"
                                v-model="file.description"
                            />
                        </div>
                    </div>
                    <div class="mb-2" v-if="filePostingType === 'add'">
                        <button type="button" class="btn btn-block border border-2" @click="addMoreMultipleFiles"><i class="bx bx-plus"></i>Add More</button>
                    </div>
                    <div class="modal-footer">
                        <button type="submit" class="btn btn-primary">
                            <i class="bx bx-save"></i> Save Changes
                        </button>
                        <button
                            type="button"
                            class="btn btn-link"
                            @click="$bvModal.hide('rfq-posting-file-modal')"
                        >
                            Close
                        </button>
                    </div>
                </form>
        </div>
    </b-modal>
</template>